<template>
    <section class="panel-body">
        <!-- <small><strong>Consumo mês</strong></small> -->
        <div class="row">
            <div class="col-12 col-sm-6 col-md-3">
                <div class="info-box bg-dark">
                    <span class="info-box-icon bg-success elevation-1"><i class="text-light fa fa-dollar"></i></span>
                    <div class="info-box-content">
                        <span class="info-box-text"><strong>Meus Pontos </strong>
                            <p class="p-0 m-0 text-center text-bold text-lg">{{auth_user.points}}</p>
                        </span>
                    </div>
                </div>
            </div>
            <div class="col-12 col-sm-6 col-md-3">
                <div class="info-box bg-dark">
                    <span class="info-box-icon bg-orange elevation-1"><i class="text-light fa fa-tag"></i></span>
                    <div class="info-box-content">
                        <router-link class="text-white" :to="{ name: 'dashboard' }">
                        <span class="info-box-text"><strong>Cupons Disponíveis</strong></span>
                       <p class="p-0 m-0 text-center text-bold text-lg">{{auth_user.tickets_count || 0}}</p>
                        </router-link>
                    </div>
                </div>
            </div>
            <div class="col-12 col-sm-6 col-md-3">
                <div class="info-box bg-dark">
                    <span class="info-box-icon bg-danger elevation-1"><i class="fa fa-qrcode"></i></span>
                    <div class="info-box-content ">
                        <router-link class="text-white" :to="{ name: 'vouchers' }">
                            <span class="info-box-text text-white"><strong>Meus Vouchers</strong></span>
                            <p class="p-0 m-0 text-center text-bold text-lg">{{auth_user.vouchers_count || 0}}</p>
                        </router-link>
                    </div>
                </div>
            </div>
            <div class="col-12 col-sm-6 col-md-3">
                <div class="info-box bg-dark">
                    <span class="info-box-icon bg-purple elevation-1"><i class="fa fa-file-text"></i></span>
                    <div class="info-box-content ">
                        <router-link class="text-white" :to="{ name: 'extrato' }">
                            <span class="info-box-text "><strong>Ver Extrato</strong></span>
                            <p class="p-0 m-0 text-center text-bold text-lg">{{auth_user.sales_count || 0}}</p>
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <template v-for="item in vouchers">
                <div class="col-md-4" :key="item.id">
                    <div class="card">
                        <div class="card-body text-gray text-center">
                            <h5 :class="{'deleted': !item.valid}"  class="text-center pb-3">{{item.ticket.title}}</h5>
                            <img class="mt-n3" :src="item.qrCode">
                            <p :class="{'deleted': !item.valid}" class="card-text text-center"><span v-html="item.ticket.description"></span></p>
                            <h2 :class="{'deleted': !item.valid}"  class="border text-bold text-center">{{item.code}}</h2>
                            <i v-if="item.date_limit" :class="{'deleted': !item.valid}" >Voucher válido até {{formatDate(item.date_limit)}}</i>
                        </div>
                    </div>
                </div>
            </template>
        </div>
    </section>
</template>
<script>
    export default {
        data() {
            return {
                loading: true,
                vouchers: []
            }
        },
        mounted() {
            this.getData();
        },
        methods: {
            getData() {
                this.$store.dispatch("getVouchers").then(response => {
                    this.vouchers = response;
                });
            },
        }
    }
</script>

<style>
    .bg-dark {
        background-color: #4b545c !important;
    }
</style>